import { gql } from '@apollo/client';

export const GET_DRAFTS_QUERY = gql`
    query getDrafts($userId: String!) {
        getDrafts(userId: $userId) {
            id
            parentPostId
            PK
            status
            hasStoryAnalysis
            storyAnalysis
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            article
            createdAt
            updatedAt
        }
    }
`;
